var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mi",class:[_vm.classes, _vm.location]})}
var staticRenderFns = []

export { render, staticRenderFns }